export const isNavV2Enabled = (search: string): boolean => {
    const navVersion = new URLSearchParams(search).get('nav')

    return navVersion !== 'v1' && navVersion !== 'legacy'
}
